import React from 'react'
import Navbar from '../layout/Navbar'
import Footer from '../layout/Footer'

const MediaandInformation = () => {
    return (
        <>
        <Navbar />
        <div className="flex items-center justify-center my-16">
            <h1 className="text-2xl font-semibold text-orange-400">
                Media & Information is coming soon
            </h1>
        </div>
        <Footer />
        </>
    )
}

export default MediaandInformation
